<template>
  <v-row>
    <v-col
      v-for="(n, index) in data"
      :key="index"
      cols="12"
      :lg="12 / data.length"
      :md="12 / (data.length <= 3 ? data.length : 3)"
      :sm="12 / (data.length <= 2 ? data.length : 2)"
      xs="12"
    >
      <div v-for="(element, index2) in n" :key="index2">
        <slot :element="element"></slot>
      </div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";

interface listObject {
  type: string;
}
export default Vue.extend({
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getXsList() {
      if (this.value.xs) {
        return this.value.xs;
      } else if (this.value.sm) {
        return this.value.sm;
      } else if (this.value.md) {
        return this.value.md;
      }
      return this.value.lg;
    },
    getSmList() {
      if (this.value.sm) {
        return this.value.sm;
      } else if (this.value.xs) {
        return this.value.xs;
      } else if (this.value.md) {
        return this.value.md;
      }
      return this.value.lg;
    },
    getMdList() {
      if (this.value.md) {
        return this.value.md;
      } else if (this.value.sm) {
        return this.value.sm;
      } else if (this.value.xs) {
        return this.value.xs;
      }
      return this.value.lg;
    },
    getLgList() {
      if (this.value.lg) {
        return this.value.lg;
      } else if (this.value.md) {
        return this.value.md;
      } else if (this.value.sm) {
        return this.value.sm;
      }
      return this.value.xs;
    },
  },
  computed: {
    data(): Array<Array<listObject>> | string | null {
      if (this.$vuetify.breakpoint.xs) {
        return this.getXsList();
      } else if (this.$vuetify.breakpoint.sm) {
        return this.getSmList();
      } else if (this.$vuetify.breakpoint.md) {
        return this.getMdList();
      } else if (this.$vuetify.breakpoint.lgAndUp) {
        return this.getLgList();
      }
      return null;
    },
  },
});
</script>
